import {
  AD_COPY_GENERATOR_TOOL,
  MARKETING_SLOGAN_TOOL,
  SOCIAL_MEDIA_BIO_TOOL,
  SYMBOLS_TOOL,
} from '@quicktools/shared-components';

export const VERSION = process.env.NX_APP_VERSION;
export const TOOL_NAME = SYMBOLS_TOOL.id;
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;
export const DEPLOY_PATH = process.env.DEPLOY_PATH;

export const appConfig = {
  appImgUrl: '',
};

export const appText = {
  toolName: 'Symbols',
  header: {
    primaryText: 'Aesthetic symbols copy & paste',
    secondaryText:
      'Help your messages and copy stand out with our aesthetic symbols copy & paste tool. Simply choose the symbol you like and copy & paste it into your app or website.',
    inputPlaceholder: 'Search symbols...',
  },
  copy: {
    defaultText: 'Copy fonts, emojis, symbols...',
    tooltip: 'Click to Copy',
  },
  categories: {
    heading: 'Category',
  },
  modal: {
    actionButton: 'Apply',
    filterHeading: 'Filter by Categories',
  },
  search: {
    matchesText: '0 matches for',
    resultsText: 'No results found',
  },
};

export const icons = {
  logo: 'https://cdn140.picsart.com/22747370631680200781.svg',
};

export const SIMILAR_TOOLS = [SOCIAL_MEDIA_BIO_TOOL, AD_COPY_GENERATOR_TOOL, MARKETING_SLOGAN_TOOL];
